import { IconWallet, IconTrend, IconRepeat } from './icons';

export const NAV_ITEMS = [
  {
    id: 'transactions',
    label: 'Opérations',
    description: 'Gérer vos transactions',
    icon: (s) => <IconWallet size={s} />,
  },
  {
    id: 'forecast',
    label: 'Prévisions',
    description: 'Voir les prévisions',
    icon: (s) => <IconTrend size={s} />,
  },
  {
    id: 'recurring',
    label: 'Paramétrage',
    description: 'Transactions récurrentes',
    icon: (s) => <IconRepeat size={s} />,
  },
];
